/* Clean River Juice Bar interactions (Oct 2026) */
(function(){
  document.documentElement.classList.add('cj-js');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function track(n, d){ try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch(e){} try { if (typeof gtag === 'function') gtag('event', n, d || {}); } catch(e){} }

  /* ---- cart count ---- */
  function setCount(n){ document.querySelectorAll('[data-cj-count]').forEach(function(el){ el.textContent = n > 0 ? n : ''; el.setAttribute('data-n', n); }); }
  function refreshCount(){ return fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }).then(function(c){ setCount(c.item_count); return c; }).catch(function(){}); }

  /* ---- toast ---- */
  var toast;
  function showToast(msg){
    if (!toast){ toast = document.createElement('div'); toast.className = 'cj-toast'; toast.setAttribute('role','status'); document.body.appendChild(toast); }
    toast.innerHTML = '<span>' + msg + '</span><a href="' + root + 'cart">View order</a>';
    toast.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(function(){ toast.classList.remove('is-on'); }, 3600);
  }

  /* ---- add to cart (cards, combo, product form) ---- */
  function addItems(items){ return fetch(root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body: JSON.stringify({items: items})}).then(function(r){ if (!r.ok) throw r; return r.json(); }); }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-cj-add]'); if (!b) return;
    e.preventDefault();
    var item = {id: +b.getAttribute('data-cj-add'), quantity: 1};
    var base = b.getAttribute('data-cj-base'); if (base) item.properties = {Base: base};
    b.disabled = true; var label = b.innerHTML; b.textContent = 'Adding…';
    addItems([item]).then(function(){
      if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
      b.classList.add('is-added'); b.textContent = 'Added ✓';
      showToast((b.getAttribute('data-cj-title') || 'Item') + ' added to your pickup order');
      track('cj_add_to_cart', {id: item.id, source: 'card'}); refreshCount();
      setTimeout(function(){ b.classList.remove('is-added'); b.innerHTML = label; b.disabled = false; }, 2200);
    }).catch(function(){ b.innerHTML = label; b.disabled = false; showToast('Sorry, that did not add. Please try again.'); });
  });
  /* product page form: keep native submit but go through AJAX for the toast */
  document.addEventListener('submit', function(e){
    var f = e.target; if (!f.matches || !f.matches('[data-cj-form]')) return;
    e.preventDefault();
    var fd = new FormData(f), props = {}, id = +fd.get('id'), qty = +(fd.get('quantity') || 1);
    fd.forEach(function(v, k){ var m = k.match(/^properties\[(.+)\]$/); if (m && v) props[m[1]] = v; });
    var btn = f.querySelector('[type=submit]'); if (btn){ btn.disabled = true; btn.dataset.l = btn.innerHTML; btn.textContent = 'Adding…'; }
    var items = [{id: id, quantity: qty, properties: props}];
    var combo = f.querySelector('[name="cj_combo"]:checked'); if (combo && combo.value) items.push({id: +combo.value, quantity: 1, properties: {Base: combo.getAttribute('data-base') || 'Alkaline water'}});
    addItems(items).then(function(){
      track('cj_add_to_cart', {id: id, source: 'product', combo: !!(combo && combo.value)}); refreshCount();
      if (f.hasAttribute('data-cj-go-cart')) { location.href = root + 'cart'; return; }
      showToast(f.getAttribute('data-cj-title') + ' added to your pickup order');
    }).catch(function(){ showToast('Sorry, that did not add. Please try again.'); })
      .then(function(){ if (btn){ btn.disabled = false; btn.innerHTML = btn.dataset.l; } });
  });
  /* $15 lunch combo builder */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-cj-combo-add]'); if (!b) return;
    var box = b.closest('[data-cj-combo]'); if (!box) return;
    var s = box.querySelector('[name=combo_sandwich]:checked'), d = box.querySelector('[name=combo_drink]:checked');
    if (!s || !d){ showToast('Pick a sandwich and a smoothie first'); return; }
    b.disabled = true; var l = b.innerHTML; b.textContent = 'Adding…';
    var bs = box.querySelector('[name=combo_base]:checked'); var fixed = d.getAttribute('data-base'); if (fixed) bs = {value: fixed};
    addItems([{id: +s.value, quantity: 1}, {id: +d.value, quantity: 1, properties: {Base: bs ? bs.value : 'Alkaline water'}}]).then(function(){
      track('cj_combo_add', {}); refreshCount(); location.href = root + 'cart';
    }).catch(function(){ b.disabled = false; b.innerHTML = l; showToast('Sorry, that did not add. Please try again.'); });
  });

  /* ---- reveal on scroll ---- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } }); }, {rootMargin:'0px 0px -8% 0px'}) : null;
  function watch(){ document.querySelectorAll('.cj-rv:not(.is-in)').forEach(function(el){ io ? io.observe(el) : el.classList.add('is-in'); }); }

  /* ---- header stuck + sticky bar ---- */
  var hd, bar, lastY = 0;
  function onScroll(){
    var y = window.scrollY;
    if (hd) hd.classList.toggle('is-stuck', y > 20);
    if (bar) bar.classList.toggle('is-on', y > 420 && !document.querySelector('.cj-pdp__buy:hover'));
    lastY = y;
  }

  /* ---- open now (Pacific time) ---- */
  function openStatus(){
    var els = document.querySelectorAll('[data-cj-open]'); if (!els.length) return;
    try {
      var now = new Date(new Date().toLocaleString('en-US', {timeZone:'America/Los_Angeles'}));
      var d = now.getDay(), m = now.getHours() * 60 + now.getMinutes();
      var close = d === 0 ? 0 : (d === 6 ? 16*60+30 : 17*60+30), order = d === 0 ? 0 : 16*60+40, open = 10*60;
      var txt;
      if (d === 0) txt = 'Closed today · Open Monday 10am';
      else if (m < open) txt = 'Opens today at 10am';
      else if (m < order) txt = 'Open now · Order online until 4:40pm';
      else if (m < close) txt = 'Open now · Walk-ins until ' + (d === 6 ? '4:30pm' : '5:30pm');
      else txt = (d === 6 ? 'Closed · Open Monday 10am' : 'Closed · Open tomorrow 10am');
      els.forEach(function(el){ el.textContent = txt; el.closest('[data-cj-open-wrap]') && el.closest('[data-cj-open-wrap]').classList.toggle('is-open', /Open now/.test(txt)); });
    } catch(e){}
  }

  /* v2 homepage: multi-item lunch builder (steppers + per-smoothie base) */
  function lunchTotal(box){
    var sum = 0;
    box.querySelectorAll('[data-cr-q]').forEach(function(r){
      var q = +r.querySelector('[data-cr-qty]').textContent || 0; sum += q * (+r.getAttribute('data-price'));
      r.classList.toggle('is-on', q > 0);
    });
    var t = box.querySelector('[data-cr-combo-total]'); if (t) t.textContent = '$' + (sum / 100).toFixed(sum % 100 ? 2 : 0);
    var b = box.querySelector('[data-cr-lunch-add]'); if (b) b.disabled = sum === 0;
  }
  document.addEventListener('click', function(e){
    var st = e.target.closest && e.target.closest('[data-cr-step]'); if (!st) return;
    var r = st.closest('[data-cr-q]'), o = r.querySelector('[data-cr-qty]');
    o.textContent = Math.max(0, Math.min(20, (+o.textContent || 0) + (+st.getAttribute('data-cr-step'))));
    lunchTotal(r.closest('[data-cj-combo]'));
  });
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-cr-lunch-add]'); if (!b) return;
    var box = b.closest('[data-cj-combo]'), items = [];
    box.querySelectorAll('[data-cr-q]').forEach(function(r){
      var q = +r.querySelector('[data-cr-qty]').textContent || 0; if (!q) return;
      var it = {id: +r.getAttribute('data-id'), quantity: q};
      if (r.hasAttribute('data-smoothie')) { var sel = r.querySelector('[data-cr-base]'); it.properties = {Base: r.getAttribute('data-base') || (sel ? sel.value : 'Alkaline water')}; }
      items.push(it);
    });
    if (!items.length) { showToast('Add at least one item first'); return; }
    b.disabled = true; var l = b.innerHTML; b.textContent = 'Adding…';
    addItems(items).then(function(){ track('cj_lunch_add', {lines: items.length}); refreshCount(); location.href = root + 'cart'; })
      .catch(function(){ b.disabled = false; b.innerHTML = l; showToast('Sorry, that did not add. Please try again.'); });
  });
  document.querySelectorAll('[data-cj-combo]').forEach(function(box){ if (box.querySelector('[data-cr-q]')) lunchTotal(box); });

  /* v2 homepage: combo total, menu tabs, rail arrows */
  document.addEventListener('change', function(e){
    var box = e.target.closest && e.target.closest('[data-cj-combo]'); if (!box) return;
    var t = box.querySelector('[data-cr-combo-total]'); if (!t) return;
    var sum = 0; box.querySelectorAll('input[data-price]:checked').forEach(function(i){ sum += +i.getAttribute('data-price'); });
    t.textContent = '$' + (sum / 100).toFixed(sum % 100 ? 2 : 0);
  });
  document.addEventListener('click', function(e){
    var tab = e.target.closest && e.target.closest('[data-cr-tab]');
    if (tab){ var k = tab.getAttribute('data-cr-tab');
      tab.parentNode.querySelectorAll('[data-cr-tab]').forEach(function(x){ x.setAttribute('aria-pressed', x === tab); });
      var rail = document.querySelector('[data-cr-rail]'); if (rail){ rail.querySelectorAll('[data-cr-kind]').forEach(function(c){ c.hidden = c.getAttribute('data-cr-kind') !== k; }); rail.scrollLeft = 0; }
      return; }
    var sl = e.target.closest && e.target.closest('[data-cr-slide]');
    if (sl){ var r = document.querySelector('[data-cr-rail]'); if (r) r.scrollBy({left: +sl.getAttribute('data-cr-slide') * r.clientWidth * .6, behavior: 'smooth'}); }
  });
  function init(){
    hd = document.querySelector('.cj-hd'); bar = document.querySelector('.cj-sticky');
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    watch(); openStatus(); refreshCount();
    document.querySelectorAll('[data-cj-menu-open]').forEach(function(b){ b.addEventListener('click', function(){ document.querySelector('.cj-drawer').classList.add('is-open'); }); });
    document.querySelectorAll('.cj-drawer').forEach(function(d){ d.addEventListener('click', function(e){ if (e.target === d || e.target.closest('[data-cj-menu-close]')) d.classList.remove('is-open'); }); });
    document.querySelectorAll('[data-cj-tabs]').forEach(function(t){
      t.addEventListener('click', function(e){
        var b = e.target.closest('[data-cj-tab]'); if (!b) return;
        var k = b.getAttribute('data-cj-tab');
        t.querySelectorAll('[data-cj-tab]').forEach(function(x){ x.setAttribute('aria-pressed', x === b); });
        document.querySelectorAll('[data-cj-kind]').forEach(function(c){ c.hidden = !(k === 'all' || c.getAttribute('data-cj-kind') === k); });
        track('cj_menu_filter', {kind: k});
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function(){ watch(); openStatus(); });
})();
/* product gallery thumbs */
document.addEventListener('click',function(e){
  var t=e.target.closest&&e.target.closest('[data-cr-thumb]'); if(!t) return;
  var wrap=t.closest('.cr-pdp__media'); var m=wrap&&wrap.querySelector('[data-cr-main]'); if(!m) return;
  m.src=t.getAttribute('data-cr-thumb');
  wrap.querySelectorAll('[data-cr-thumb]').forEach(function(x){x.setAttribute('aria-pressed',x===t);});
});
